// Auto-generated by scripts/generate-env.cjs — do not edit. Values from Passport/.env (and process.env).
export const VITE_API_URL = "";
export const VITE_FIREBASE_API_KEY = "AIzaSyDNjhoxKN5ddNtVqoezi3eijlHlysequmE";
export const VITE_FIREBASE_AUTH_DOMAIN = "tranzitti-90210.firebaseapp.com";
export const VITE_FIREBASE_PROJECT_ID = "tranzitti-90210";
export const VITE_FIREBASE_STORAGE_BUCKET = "tranzitti-90210.firebasestorage.app";
export const VITE_FIREBASE_MESSAGING_SENDER_ID = "243323136379";
export const VITE_FIREBASE_APP_ID = "1:243323136379:web:f79eaf6656d11e3c1b5de";
export const VITE_FIREBASE_API_KEY_SECONDARY = "";
export const VITE_FIREBASE_AUTH_DOMAIN_SECONDARY = "";
export const VITE_FIREBASE_PROJECT_ID_SECONDARY = "";
export const VITE_FIREBASE_STORAGE_BUCKET_SECONDARY = "";
export const VITE_FIREBASE_MESSAGING_SENDER_ID_SECONDARY = "";
export const VITE_FIREBASE_APP_ID_SECONDARY = "";
export const VITE_PASSPORT_TURNSTILE_SITE_KEY = "0x4AAAAAADVfFUilHWGHbd10";
export const VITE_VVID_MAX_FILE_BYTES = 5242880;
export const VITE_VVID_STORAGE_PATH_PREFIX = "carrierPassports/";
export const VITE_PASSPORT_DOCUMENT_PACKAGE_ENABLED = "true";
export const VITE_PASSPORT_DOCUMENT_PACKAGE_EXTERNAL_EMAIL = "true";
export const VITE_PASSPORT_PLA_ENABLED = "true";
export const VITE_PASSPORT_PLA_RC_REQUIRED = "true";
export const VITE_PASSPORT_COMPLIANCE_MALWARE_SCAN_ENABLED = "";
export const VITE_PASSPORT_FLEET_ORG_ENABLED = "true";
export const VITE_PASSPORT_CMV_ENABLED = "true";
export const VITE_PASSPORT_OUTSIDE_NETWORK_INVITE_ENABLED = "true";
export const VITE_FIREBASE_APP_CHECK_RECAPTCHA_SITE_KEY = "";
export const VITE_FIREBASE_APP_CHECK_DEBUG_TOKEN = "";